import { getType, isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, map, mergeMap, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { AxiosError } from 'axios'
import { AnyAction } from 'redux'
import { RootEpic } from '../types'
import {
  getAssetsRequest,
  getAssetsSuccess,
  getAssetsFailure,
  createAssetRequest,
  createAssetSuccess,
  createAssetFailure,
  updateAssetRequest,
  updateAssetSuccess,
  updateAssetFailure,
  getInstrumentsForCreateAssetRequest,
  getInstrumentsForCreateAssetSuccess,
  getInstrumentsForCreateAssetFailure,
} from '../actions'

export const fetchAssetsEpic: RootEpic = (action$, state$, { fetchAssets }) =>
  action$.pipe(
    filter(isActionOf([getAssetsRequest])),
    switchMap(({ type, payload }) =>
      from(
        fetchAssets({
          token: state$.value.app.authToken as string,
          limit: 10,
          ...state$.value.assets.filters,
          ...(type === getType(getAssetsRequest) && payload),
        }),
      ).pipe(
        map((response) => getAssetsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch assets.')
          return of(getAssetsFailure(message))
        }),
      ),
    ),
  )

export const getInstrumentsForCreateAssetEpic: RootEpic = (action$, state$, { getInstrumentsForCreateAsset }) =>
  action$.pipe(
    filter(isActionOf([getInstrumentsForCreateAssetRequest])),
    switchMap(({ payload }) =>
      from(
        getInstrumentsForCreateAsset({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => getInstrumentsForCreateAssetSuccess(response)),
        catchError((message) => {
          toast.error('Failed to get instruments for create asset.')
          return of(getInstrumentsForCreateAssetFailure(message))
        }),
      ),
    ),
  )

export const createAssetEpic: RootEpic = (action$, state$, { createAsset }) =>
  action$.pipe(
    filter(isActionOf([createAssetRequest])),
    exhaustMap(({ payload }) =>
      from(
        createAsset({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        mergeMap((response) => {
          const actions: Array<AnyAction> = []
          if (response.success) {
            toast.success(response.message)
            actions.push(getAssetsRequest({ page: 1 }))
          } else {
            toast.error(response.message)
          }
          actions.push(createAssetSuccess(response))
          return of(...actions)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to create asset.')
          return of(createAssetFailure(error))
        }),
      ),
    ),
  )

export const updateAssetEpic: RootEpic = (action$, state$, { updateAssets }) =>
  action$.pipe(
    filter(isActionOf([updateAssetRequest])),
    exhaustMap(({ payload }) =>
      from(
        updateAssets({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        mergeMap((response) => {
          const actions: Array<AnyAction> = []
          if (response.success) {
            toast.success(response.message)
            actions.push(getAssetsRequest({ page: 1 }))
          } else {
            toast.error(response.message)
          }
          actions.push(updateAssetSuccess(response))
          return of(...actions)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update assets.')
          return of(updateAssetFailure(error))
        }),
      ),
    ),
  )

export default [fetchAssetsEpic, getInstrumentsForCreateAssetEpic, createAssetEpic, updateAssetEpic]
